import { render, staticRenderFns } from "./addDynamic.vue?vue&type=template&id=642cb51c&scoped=true&"
import script from "./addDynamic.vue?vue&type=script&lang=js&"
export * from "./addDynamic.vue?vue&type=script&lang=js&"
import style0 from "./addDynamic.vue?vue&type=style&index=0&id=642cb51c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642cb51c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('642cb51c')) {
      api.createRecord('642cb51c', component.options)
    } else {
      api.reload('642cb51c', component.options)
    }
    module.hot.accept("./addDynamic.vue?vue&type=template&id=642cb51c&scoped=true&", function () {
      api.rerender('642cb51c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dynamic/communityDynamic/communityDynamicHome/components/addDynamic.vue"
export default component.exports